import { render } from "./consulta.vue?vue&type=template&id=2ba2c1bf&scoped=true"
import script from "./consulta.vue?vue&type=script&lang=js"
export * from "./consulta.vue?vue&type=script&lang=js"

import "./consulta.vue?vue&type=style&index=0&id=2ba2c1bf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba2c1bf"]])

export default __exports__